
import { computed, defineComponent, onMounted, PropType, Ref, ref, watch } from 'vue'

import useValidationMessages from '@/common/composable/useValidationMessages'
import { ErrorObject } from '@vuelidate/core'

export default defineComponent({
    props: {
        value: {
            type: String,
            default: null,
        },
        accesskey: {
            type: String,
            default: null,
        },
        autofocus: {
            type: Boolean,
            default: false,
        },
        cols: {
            type: Number,
            default: null,
        },
        rows: {
            type: Number,
            default: null,
        },
        maxlength: {
            type: Number,
            default: null,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: null,
        },
        isInvalid: {
            type: Boolean,
            default: false,
        },
        autoheight: {
            type: Boolean,
            default: false,
        },
        validationErrors: {
            type: Array as PropType<ErrorObject[]>,
            default: () => [],
        },
    },
    emits: ['update:value'],
    setup(props, { emit }) {
        const textarea = ref(null) as Ref<null | HTMLTextAreaElement>

        const autoResize = () => {
            if (!textarea.value) return
            const textarea_scrollheight = textarea.value.scrollHeight

            if (!props.value || props.value === '') {
                textarea.value.style.setProperty('height', 'auto')
            } else {
                textarea.value.style.setProperty('height', `${textarea_scrollheight}px`)
            }
        }

        const emitInput = (event: Event) => {
            const target = event.target as HTMLTextAreaElement
            emit('update:value', target.value)

            if (props.autoheight) {
                autoResize()
            }
        }

        onMounted(() => {
            if (!props.autoheight || !textarea.value) return
            autoResize()
        })

        if (props.autoheight) {
            watch(
                () => props.value,
                () => {
                    setTimeout(autoResize, 100)
                }
            )
        }

        const { getValidationMessage } = useValidationMessages()

        const getLengthLabel = computed(() => {
            const current_length = props.value ? props.value.length : 0,
                max_length = props.maxlength || 255

            return `${current_length} / ${max_length}`
        })

        return { emitInput, textarea, getValidationMessage, getLengthLabel }
    },
})
